<template>
	<div class="py-3 px-3">
		<div class="row">
			<div class="col-md-12">
				<div class="card cardptpr mb-4">
					<div class="card-header p-3 pb-0 pt-0">
						<H6>SATGAS REPORT</H6>
					</div>
					<div class="card-body p-3 pt-4">
						<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
							<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
								<SatgasReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>	
			</div>

		</div>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
import SatgasReportTab from '@/views/pages/SatgasReportTab.vue'


export default
{
	extends:Fuel,
	components: {
		SatgasReportTab,
	},
	data() {
		return {
			tabList:[
				/*
				{name:'Sales'},
				{name:'Losses'},
				{name:'Payment'},
				{name:'Stock'},
				//{name:'shift'},
				//{name:'transaction'},
				//{name:'tank delivery'},
				//{name:'oil flow'},*/
				{label:'Sales', name: 'sales', index: '0' },
				{label:'Sales BBK Kemasan', name: 'sales_kemasan', index: '9' },
				//{label:'Losses', name: 'losses', index: '1' },
				//{label:'Payment', name: 'payment', index: '2' },
                {label:'Stock Modular', name: 'stock', index: '3' },
				/*
                {label:'Shift', name: '4'},
                {label:'Transaction', name: '5'},
				{label:'Tank delivery', name: '6'},
				{label:'Oil Flow', name: '7'},
				*/
				{label:'Stock BBK Kemasan', name: 'stock_kemasan', index: '8' },
			],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 

		}
	},

	watch: {

	},      
	mounted() {
		this.$emit('childrenRoute')
	},
	methods: {
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label

			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

	},

}
</script>

<style>
 

</style>